<template>
    <div class="single-game" :class="currentGame" @click="$emit('setSwipe')">
      <img :src="imageLink" :alt="imageAlt">
    </div>
</template>

<script>
export default {
  props: {
    isActiveButton: {
      type: Boolean,
      default: false
    },
    imageLink: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentGame: function () {
      return this.isActiveButton ? 'current-game' : ''
    }
  }
}
</script>
